(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Carga GSAP si no existe
  function ensureGSAP(cb) {
    if (window.gsap) return cb();
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
    s.async = true;
    s.onload = cb;
    s.onerror = function(){ console.warn('GSAP CDN failed to load.'); };
    document.head.appendChild(s);
  }

  function initRoot(root) {
    if (!root || root.dataset.gsapInited === '1') return;
    root.dataset.gsapInited = '1';

    ensureGSAP(function () {
      var h1 = root.querySelector('.hero__h1');
      var h2 = root.querySelector('.hero__h2');
      var buttons = root.querySelectorAll('.hero__actions a');
      var images = root.querySelectorAll('.column__2 img');
      var buttonLeft = root.querySelector('.btn--primary');
      var buttonRight = root.querySelector('.btn--secondary');

      var tl = gsap.timeline({ defaults: { duration: 0.9, ease: 'power3.out' } });
      if (h1) tl.from(h1, { y: 50, opacity: 0 });
      if (h2) tl.from(h2, { y: 40, opacity: 0 }, '-=0.6');
      if (buttonLeft) tl.from(buttonLeft, { x: -30, opacity: 0 }, '-=0.4');
      if (buttonRight) tl.from(buttonRight, { x: 30, opacity: 0 }, '-=0.9');
      // if (buttons && buttons.length) tl.from(buttons, { y: 30, opacity: 0, stagger: 0.15 }, '-=0.4');
      if (images && images.length) tl.from(images, { scale: 1.15, opacity: 0, stagger: 0.2, duration: 0.8 }, '-=0.5');
    });
  }

  function initAll() {
    document.querySelectorAll('[data-hero-root]').forEach(initRoot);
  }

  // Carga normal (preview/navegador)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Soporte Theme Editor (hot reload)
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-hero-root]');
    if (root) initRoot(root);
  });
  document.addEventListener('shopify:section:select', function (e) {
    var root = e.target.querySelector('[data-hero-root]');
    if (root) initRoot(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
